<template>
  <div>
    <canvas :id="'line-chart-' + uniqueId"></canvas>
  </div>
</template>

<script>
    import Chart from 'chart.js';

    export default {
        props: {
            uniqueId:  { type: Number },
            datasetY1: { type: Array },
            datasetY2: { type: Array },
        },
        data() {
            return {
                chart: undefined
            }
        },
        mounted() {
            let ctx = document.getElementById('line-chart-' + this.uniqueId);
            this.chart = Chart.Line(ctx, {
                data: {
                    labels: [],
                    legend: {
                        display: false
                    },
                    datasets: [{
                        fill: false,
                        data: this.datasetY1,
                        yAxisID: 'y-axis-1',
                        label: 'SG',
                        backgroundColor: "#4C91BA",
                        borderColor: "#4C91BA",
                        type: 'line',
                        pointRadius: 1,
                        lineTension: 0,
                        borderWidth: 2
                    },
                    {
                        fill: false,
                        data: this.datasetY2,
                        yAxisID: 'y-axis-2',
                        label: 'Temperature',
                        backgroundColor: "#ED774A",
                        borderColor: "#ED774A",
                        type: 'line',
                        pointRadius: 1,
                        lineTension: 0,
                        borderWidth: 2
                    }
                    ]
                },
                options: {
                    // animation: true,
                    responsive: true,
                    aspectRatio: 1.5,
                    scales: {
                        yAxes: [{
                            type: 'linear',
                            fontFamily: 'Roboto',
                            display: true,
                            position: 'left',
                            id: 'y-axis-1',
                            ticks: {
                                suggestedMin: 1.000,
                                suggestedMax: 1.070
                            },
                            scaleLabel: {
                                display: false,
                                labelString: 'Specific Gravity'
                            }
                        },
                        {
                            type: 'linear',
                            display: true,
                            fontFamily: 'Roboto',
                            position: 'right',
                            id: 'y-axis-2',
                            scaleLabel: {
                                display: false,
                                labelString: `Temperature (${this.temperatureUnit()})`
                            },
                            ticks: {
                                suggestedMin: 10,
                                suggestedMax: 30
                            },

                            gridLines: {
                                drawOnChartArea: false,
                            },
                        }],
                        xAxes: [{
                            scaleLabel: {
                                display: false,
                                labelString: 'Time'
                            },
                            fontFamily: 'Roboto',
                            type: 'time',
                            distribution: 'series',
                            offset: true,
                            time: {
                                tooltipFormat: "MMMM Do YYYY",
                                unit: 'day',
                                displayFormats: {
                                    hour: 'MMMM Do YYYY'
                                }
                            },
                            ticks: {
                                maxRotation: 45,
                                minRotation: 45,
                                source: 'data',
                                autoSkip: true,
                                autoSkipPadding: 75,
                                sampleSize: 100
                            }
                        }],
                    }
                }
            });
        }
    }
</script>

<style scoped lang="scss">
  div {
  }
</style>
